import cnh from '~/helpers/cnh';
import formStyles from '~/styles/form.module.css';

type Props = {
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
  visuallyHidden?: boolean;
  required?: boolean;
};

export default function FormLabel({
  children,
  className,
  htmlFor,
  visuallyHidden = false,
  required = false,
}: Props) {
  return (
    <label
      htmlFor={htmlFor}
      className={cnh(
        formStyles.formLabel,
        className,
        visuallyHidden ? formStyles.formLabelVisuallyHidden : undefined,
      )}
    >
      {children}
      {required && <span className={formStyles.formLabelRequired}>*</span>}
    </label>
  );
}
